import { useMutation } from "react-query";
import { extendedPostJSON } from "../api/http";
import { endpoints } from "../api/endpoints";
import { useState } from "react";

interface ISms {
  pin?: string;
}

const postContractDeclarationSms = (id: string, data: any) =>
  extendedPostJSON(endpoints.contracts.declaration + `/${id}/sign`, data);

export const useContractDeclarationSms = (id: string) => {
  const [errors, setErrors] = useState<string[]>([]);
  const [action, setAction] = useState("");

  const { mutate, isLoading, isSuccess, isError, reset } = useMutation(
    (data: ISms) => postContractDeclarationSms(id, data),
    {
      onSuccess: ({ data }) => {
        if (data === true) {
          setAction("sign_confirmed");
        } else if (data > 0) {
          setAction("sms_send");
        }
      },
      onError: (error: any) => {
        setErrors(Object.values(error?.data.errors || {}));
      },
      onSettled: () => {},
    }
  );

  return {
    isLoading,
    isSuccess,
    isError,
    errors,
    action,
    sms: mutate,
    resetForm: reset,
  };
};
